import { useDispatch, useSelector } from 'react-redux';
import { startLoading, stopLoading } from '@/store/modules/loaderSlice';

type UseLoadingReturn = {
    isLoading: boolean;
    start: (message?: string) => void;
    stop: () => void;
};

export const useLoading = (scope?: string): UseLoadingReturn => {
    const dispatch = useDispatch();

    // Select scoped or global loading state based on the scope
    const isLoading = useSelector((state: any) =>
        scope
            ? !!state.loading.scopes[scope]?.isLoading
            : state.loading.isLoading
    );

    const start = (message?: string) => {
        dispatch(
            startLoading({
                scope,
                message,
            })
        );
    };

    const stop = () => {
        dispatch(stopLoading({ scope }));
    };

    return { isLoading, start, stop };
};
